import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { makeStyles } from '@material-ui/core/styles';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { setMerchandiseCost, setActiveTab } from '../actions/actions';
import { withStyles } from '@material-ui/core/styles';
import {Slider, Typography, Container} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const ContentArea = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  margin: 16px;
  @media (min-width: 801px) {
    border-right: 1px solid #8080803d;
  };`;

  const TabTitle = styled(Typography)`
  place-self: center;
  margin-right: 12px !important;
  margin-top: 16px !important;
`;

const ItemContainer = styled(Container)`
    margin: 12px;
`

const BackButton = styled(Button)`
width: auto;
max-width: 800px;
justify-self: start;
align-self: center;
margin-left: 28px !important;
@media (max-width: 768px) {
  span {
    display: none;
  }
  :after {
    content: '<';
    font-size: 16px;
  }
}
`
const NavArea = styled.div`
display: grid;
grid-template-columns: auto auto;
`;


const NextButton = styled(Button)`
width: auto;
max-width: 800px;
justify-self: end;
align-self: center;
margin-right: 28px !important;
@media (max-width: 768px) {
  span {
    display: none;
  }
  :after {
    content: '>';
    font-size: 16px;
  }
}
`

const ResponsiveContainer = styled(Container)`
  margin: 24px;
}
`

const PrettoSlider = withStyles({
  root: {
    color: '#e45306',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

function createData(name, cmv, rot, ticket) {
  return { name, cmv, rot, ticket };
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    marginTop: 12
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const rows = [
  createData('Econômico', "35%", "3 a 5", "Até 15,00"),
  createData('Familiar', "33%", "2 a 4", "15,00 a 35,00"),
  createData('Moderado', "30%", "1,5 a 2,5", "35,00 a 70,00"),
  createData('Luxo', "25%", "Até 1,5", "Acima de 70,00"),
];

function TabContent(props) {
  const classes = useStyles();
  let timeout =  null

  const handleSliderChange = (event, value) => {
    timeout = setTimeout(function () {
      props.setMerchandiseCost(value)
    }, 500);
  }
  
  return (
    <ContentArea>
      <TabTitle variant="h4">Custo de mercadoria %</TabTitle>
      <ItemContainer>
      <PrettoSlider valueLabelDisplay="auto" aria-label="pretto slider" defaultValue={props.financialSetup.merchandiseCost} max={100} min={0} onChange={handleSliderChange}/>
      </ItemContainer>
      <Container>
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Custo de mercadoria %</TableCell>
                  <TableCell>Rotatividade típica</TableCell>
                  <TableCell>Tiquete médio (R$)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  
                  <TableRow key={row.name}>
                    <TableCell scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell scope="row"><b>{row.cmv}</b></TableCell>
                    <TableCell scope="row">{row.rot}</TableCell>
                    <TableCell scope="row">{row.ticket}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <small>Fonte: Livro Gestão da Gastronomia</small>
      </Container>
      <ResponsiveContainer>
        <Typography variant="h6">Ajuda</Typography>
        <Typography variant="body">Informe o custo percentual de sua mercadoria em relação ao faturamento. Quanto maior esse percentual, menor será o seu lucro operacional.</Typography>
      </ResponsiveContainer>
      <NavArea>
        <BackButton
          variant="contained"
          onClick={() => props.setActiveTab(props.activeTab - 1)}
          color="secondary"
          disabled={props.financialSetup.revenue <= 0}
          startIcon={<NavigateBeforeIcon />}
        >
          Voltar
        </BackButton>
        <NextButton
          variant="contained"
          onClick={() => props.setActiveTab(props.activeTab + 1)}
          color="secondary"
          disabled={props.financialSetup.revenue <= 0}
          endIcon={<NavigateNextIcon />}
        >
          Próximo
        </NextButton>
      </NavArea>
    </ContentArea>
  );
}

const mapStateToProps = (state) => {
  return {
    financialSetup: state.reducers.financialSetup,
    activeTab: state.reducers.activeTab
  }
}

const mapDispatchToProps = { setMerchandiseCost, setActiveTab }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabContent)
